export enum MessageBlockType {
  DISCUSSION = 'DISCUSSION',
  CONTENT = 'CONTENT',
  THOUGHT = 'THOUGHT',
}

interface PartialNotePart {
  text?: string;
}

interface DiscussionMessageBlock {
  type: MessageBlockType.DISCUSSION;
  text: string;
}

interface ContentMessageBlock {
  type: MessageBlockType.CONTENT;
  partialNoteParts: Array<PartialNotePart>;
}

interface ThoughtMessageBlock {
  type: MessageBlockType.THOUGHT;
  text: string;
}

type MessageBlock = DiscussionMessageBlock | ContentMessageBlock | ThoughtMessageBlock;

/**
 * Message from the LLM in response to a request to write notebook content or answer a question.
 *
 * The message may consist of multiple parts called "blocks", which makes it possible to
 * distinguish between messages to the user, proposed entry content, and internal thoughts from
 * the LLM.
 *
 * This type must exactly match the format sent by the server.
 */
export interface GenerateDocumentContentMessage {
  messageBlocks: Array<MessageBlock>;
}

export enum CheckEntryResponseState {
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export enum CheckEntryResultUsefulState {
  USEFUL = 'USEFUL',
  NOT_USEFUL = 'NOT_USEFUL',
  UNMARKED = 'UNMARKED',
}

export type DisplayCheckEntryResults =
  | {state: CheckEntryResponseState.LOADING; loadingState: string}
  | {state: CheckEntryResponseState.ERROR; errorMessage: string | null}
  | {
      state: CheckEntryResponseState.SUCCESS;
      traceId: string;
      results: Array<CheckEntryDisplayResult>;
      checkedAt: string;
      checkedVersion: number;
    };

export interface CheckEntryDisplayResult {
  text: string;
  isCompleted: boolean;
  usefulState: CheckEntryResultUsefulState;
}

export enum FlexibleDataEntryExperience {
  POPOVER = 'popover',
  MODAL = 'modal',
}
